module.exports = __webpack_public_path__ + "static/frameblender.e7787e5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clients/frameblender.png
// module id = 246
// module chunks = 35783957827783 269829036549620